
import './contact.css'
import contactimage from '../../img/contact.png'
export default function Contact(){
    return(
        <div className='contactpage'>
            <div className='contactbox'>
            <p><strong>آدرس:</strong> تهران کیلومتر 11 بزرگراه شهید لشکری خیابان 29 انتهای خیابان کارخانه تهران مو</p>
              <p><strong>شماره تماس:</strong> 021-44906718</p>
              <p><strong>پشتیبانی:</strong> 09396794589</p>
              <p><strong>اینستاگرام:</strong> <a href="https://instagram.com/mahoganyacademy"> mahoganyacademy</a></p>
              <p><strong>ایمیل:</strong> academymahogany1@gmail.com</p>
              <p><strong>کانال تلگرام:</strong> <a href="https://t.me/+XZA2bDLELjUxNGU8"> Telegram</a></p>
            </div>
            <img className='contactimage' src={contactimage} alt='contant'></img>
        </div>
    )
}